mySynch.directive('pnlMaskUppercaseAlphaNumeric', [function pnlMaskUppercaseAlphaNumeric() {
	return {
		restrict: 'A',
		link: function pnlMaskUppercaseLink(scope, elem, attrs) {
			elem.bind('keypress input blur', function bindInput(e) {
				var originalValue = this.value;
				var newValue = this.value;
				newValue = newValue.toUpperCase().replace(/[^A-Z1-9]/g, '');

				var originalSelectionStart = e.currentTarget.selectionStart;

				this.value = newValue;

				if (originalSelectionStart !== originalValue.length) {
					e.currentTarget.selectionStart = originalSelectionStart;
					e.currentTarget.selectionEnd = originalSelectionStart;
				}

				_.set(scope, attrs.ngModel, newValue);
			});
			elem.addClass('uppercase');	//	make it display uppercase in addition to changing text
		}
	};
}]);
